import { CheckCircleFilled, WarningFilled, CloseCircleFilled, QuestionCircleFilled } from '@ant-design/icons';
import type { HealthStatus } from '@/api/systemHealth';

// One meaning per health status — read by the System Health page and by the
// System health dot in the right rail, so the two can never disagree on what
// "degraded" looks like.
export const HEALTH_STATUS_META: Record<HealthStatus, { color: string; label: string; icon: React.ReactNode }> = {
  ok: { color: '#059669', label: 'Healthy', icon: <CheckCircleFilled /> },
  degraded: { color: '#D97706', label: 'Degraded', icon: <WarningFilled /> },
  down: { color: '#DC2626', label: 'Down', icon: <CloseCircleFilled /> },
  unknown: { color: '#6B7280', label: 'Unknown', icon: <QuestionCircleFilled /> },
};
